var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/react/ResetNodePlugin.tsx
import { toPlatePlugin } from "@udecode/plate-common/react";

// src/lib/BaseResetNodePlugin.ts
import {
  createTSlatePlugin,
  getEndPoint,
  getNode,
  getNodeProps,
  getStartPoint,
  isCollapsed,
  resetEditorChildren,
  setNodes,
  unsetNodes,
  withoutNormalizing
} from "@udecode/plate-common";
import { Point } from "slate";
var BaseResetNodePlugin = createTSlatePlugin({
  key: "resetNode",
  extendEditor: ({ editor, getOptions }) => {
    const { deleteBackward, deleteFragment } = editor;
    editor.deleteFragment = (direction) => {
      const deleteFragmentPlugin = () => {
        const { selection } = editor;
        if (!selection) return;
        const start = getStartPoint(editor, []);
        const end = getEndPoint(editor, []);
        if (Point.equals(selection.anchor, start) && Point.equals(selection.focus, end) || Point.equals(selection.focus, start) && Point.equals(selection.anchor, end)) {
          resetEditorChildren(editor, {
            insertOptions: { select: true }
          });
          return true;
        }
      };
      if (!getOptions().disableEditorReset && deleteFragmentPlugin()) return;
      deleteFragment(direction);
    };
    editor.deleteBackward = (unit) => {
      if (!getOptions().disableFirstBlockReset) {
        const { selection } = editor;
        if (selection && isCollapsed(selection)) {
          const start = getStartPoint(editor, []);
          if (Point.equals(selection.anchor, start)) {
            const node = getNode(editor, [0]);
            const _a = editor.api.create.block({}, [0]), { children } = _a, props = __objRest(_a, ["children"]);
            withoutNormalizing(editor, () => {
              const _a2 = getNodeProps(node), { id } = _a2, nodeProps = __objRest(_a2, ["id"]);
              unsetNodes(editor, Object.keys(nodeProps), { at: [0] });
              setNodes(editor, props, { at: [0] });
            });
            return;
          }
        }
      }
      deleteBackward(unit);
    };
    return editor;
  },
  options: {
    rules: []
  }
});

// src/react/onKeyDownResetNode.ts
import {
  isCollapsed as isCollapsed2,
  isHotkey,
  setElements,
  someNode
} from "@udecode/plate-common";
var SIMULATE_BACKSPACE = {
  key: "",
  which: 8
};
var onKeyDownResetNode = ({
  editor,
  event,
  getOptions
}) => {
  const { rules = [] } = getOptions();
  if (event.defaultPrevented) return;
  let reset;
  if (!editor.selection) return;
  if (isCollapsed2(editor.selection)) {
    rules.forEach(({ defaultType, hotkey, predicate, types, onReset }) => {
      var _a;
      if (hotkey && isHotkey(hotkey, event) && predicate(editor) && someNode(editor, { match: { type: types } })) {
        (_a = event.preventDefault) == null ? void 0 : _a.call(event);
        setElements(editor, { type: defaultType });
        if (onReset) {
          onReset(editor);
        }
        reset = true;
      }
    });
  }
  return reset;
};

// src/react/ResetNodePlugin.tsx
var ResetNodePlugin = toPlatePlugin(BaseResetNodePlugin, {
  handlers: {
    onKeyDown: onKeyDownResetNode
  }
});
export {
  ResetNodePlugin,
  SIMULATE_BACKSPACE,
  onKeyDownResetNode
};
//# sourceMappingURL=index.mjs.map